const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-19pateras/PNG%20n.1/PSD%2019%20-%20PA/19-1w/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 19n Level 1 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
